// extracted by mini-css-extract-plugin
export var blogDate = "blog-template-module--blog-date--ES4h0";
export var blogMain = "blog-template-module--blog-main--njB99";
export var blogPostContent = "blog-template-module--blog-post-content--mUm44";
export var blogPostShareButtons = "blog-template-module--blog-post-share-buttons--kCE0Y";
export var blogPostShareContainer = "blog-template-module--blog-post-share-container--LVCI0";
export var blogPostShareText = "blog-template-module--blog-post-share-text--Bkntv";
export var blogTags = "blog-template-module--blog-tags--XpuGz";
export var blogTemplate = "blog-template-module--blog-template--68Q1Z";
export var blogTitle = "blog-template-module--blog-title--NJsl4";